// extracted by mini-css-extract-plugin
export default {"cls1":"wLjkfP0UScLjzZdPpi49","cls2":"I6w7lTzHcchROsHAPtc7 wLjkfP0UScLjzZdPpi49","isTabletUp":"DfLsAp5t9abPbLhrfpLF"};